<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="4">
        <h2>Cambio de Contraseña</h2>
        <UpdatePasswordUserForm :model="password" :on-success="savePassword" :on-cancel="cancel"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import UpdatePasswordUserForm from '@/components/forms/UpdatePasswordUserForm'
export default {
  data: () => ({
    user: {},
    password: {}
  }),
  components: {
    UpdatePasswordUserForm
  },
  mounted () {
    this.user = this.$cookies.get('user_sirh')
    console.log('user', this.user)
  },
  methods: {
    ...mapActions(['postServiceAction']),
    savePassword (model) {
      model.id = this.user.id
      console.log('model', model)
      const router = this.get_urls['POST/config/auth/usuarios/change-password']
      this.postServiceAction({ url: router, data: model })
    },
    cancel () {
      this.password = {}
    },
    ...mapMutations([])
  },
  computed: {
    ...mapGetters(['get_urls', 'get_object'])
  },
  watch: {
    get_object (val) {
      if (val) {
        if (val.message) {
          this.$swal({
            type: 'error',
            icon: 'error',
            title: 'Error!',
            text: val.message
          })
          return
        }
        this.$swal({
          type: 'success',
          icon: 'success',
          title: 'Exitoso !',
          text: 'Registro Actualizado Correctamente'
        })
        this.password = {}
      }
    }
  }
}
</script>
